import { DateTime } from 'luxon';

export const formatLocalTime = (date: Date, format?: string): string =>
  DateTime.fromJSDate(date)
    .setLocale('tr')
    .toFormat(format ?? 'd MMMM yyyy HH:mm');

export const formatLocalDate = (date: Date): string =>
  formatLocalTime(date, 'dd LLLL yyyy');
